// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"64191b57","455":"ad2ff945"}[chunkId] + ".chunk.js";
};